<template>
    <div class="d-flex align-items-center gap-2">
        <button
            class="btn btn-sm"
            :class="isFluid ? 'btn-primary' : 'btn-light'"
            @click="setFluid"
        >
            Fluid
        </button>

        <button
            class="btn btn-sm"
            :class="!isFluid ? 'btn-primary' : 'btn-light'"
            @click="setDefault"
        >
            Default
        </button>
    </div>
</template>

<script>
import layoutConfig from "@/core/config/DefaultLayoutConfig.js";

export default {
    name: "ContentWidthSwitcher",

    computed: {
        isFluid() {
            return layoutConfig.content.width === "fluid";
        },
    },

    methods: {
        setFluid() {
            layoutConfig.content.width = "fluid";
            localStorage.setItem("contentWidth", "fluid");
        },

        setDefault() {
            layoutConfig.content.width = "default";
            localStorage.setItem("contentWidth", "default");
        },
    },
};
</script>

